export default __webpack_public_path__ + "static/media/windows.8d7392cc.png";